module.exports = __webpack_public_path__ + "media/Winners Response.3b2eaca4.mp3";